import React from 'react';
import { observer } from 'src/utils/mobx-react';

interface InfoBoxPropsType {
    children: React.ReactNode;
}

export const InfoBox = observer('InfoBox', ({ children }: InfoBoxPropsType) => {
    return <article className='p-3 rounded-sm bg-white shadow-sm'>{children}</article>;
});
